import React from "react";
import style from "./style.module.css";
import PlusIcon from "views/components/icons/PlusIcon";
import MultiLineEllipsis from "views/components/MultiLineEllipsis/MultiLineEllipsis";
import PrintOptionsButtonContainer from "views/containers/PrintOptionsButtonContainer/PrintOptionsButtonContainer";
import DesignSizeLabel from "views/components/DesignSizeLabel";

export const InfoPanelTop = ({ selectedDesign, handleCloseModal }) => {
  return (
    <div className={style.infoPanelTop}>
      <div className={style.closeModalButton}>
        <PlusIcon
          className={style.closeButton}
          rotate="45"
          size="18px"
          onClick={handleCloseModal}
        />
      </div>
      <MultiLineEllipsis clamp={4} className={style.selectedDesignTitle}>
        {selectedDesign.title}
      </MultiLineEllipsis>
      <div className={style.selectedDesignSize}>
        <DesignSizeLabel design={selectedDesign} as="span" withMeasurements />
      </div>
      <PrintOptionsButtonContainer selectedDesign={selectedDesign} />
    </div>
  );
};

InfoPanelTop.displayName = "InfoPanelTop";

export default InfoPanelTop;
